var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme, TRANSITION } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ChevronRightIconGlyph } from '@shapeable/icons';
import { IconLabel } from './icon-label';
import { useLink } from '../hooks/use-link';
import { useLang } from '../hooks/use-lang';
var cls = classNames('icon-label-link');
export var IconLabelLinkDefaultProps = {
  label: 'link button'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var IconLabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 1em;\n\n    &:hover {\n      color: ", ";\n      ", ";\n      ", ";\n    }\n  "], ["\n    font-size: 1em;\n\n    &:hover {\n      color: ", ";\n      ", ";\n      ", ";\n    }\n  "])), theme.COLOR('mid'), theme.FILL('mid'), TRANSITION('color', 'fill'))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  IconLabel: styled(IconLabel)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), IconLabelStyles)
};
export var IconLabelLink = function (props) {
  var className = props.className,
    href = props.href,
    label = props.label;
  var Link = useLink().Link;
  var t = useLang();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(Link, {
    href: href,
    style: {
      textDecoration: 'none'
    }
  }, React.createElement(My.IconLabel, {
    iconSize: 12,
    reverse: true,
    icon: React.createElement(ChevronRightIconGlyph, null)
  }, t(label))));
};
IconLabelLink.cls = cls;
IconLabelLink.defaultProps = IconLabelLinkDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;